import { Task } from "../types";
import { BarzhaResponse, BarzhaStatusTask } from "./sponsors/types/barzha";
import { TappAdsTask, TappAdsStatusTask } from "./sponsors/types/tappads";
import { DreamcoinResponse } from "./sponsors/types/dreamcoin";
import { BarzhaAdapter } from "./sponsors/BarzhaAdapter";
import { TappAdsAdapter } from "./sponsors/TappAdsAdapter";
import { DreamcoinClickAdapter } from "./sponsors/DreamcoinClickAdapter";
import { DreamcoinSubscribeAdapter } from "./sponsors/DreamcoinSubscribeAdapter";
import { BarzhaClickAdapter } from "./sponsors/BarzhaClickAdapter";
import { FlyerStatusTask, FlyerTask } from "./sponsors/types/flyer";
import { FlyerAdapter } from "./sponsors/FlyerAdapter";

export enum SponsorType {
  BARZHA = "barzha",
  TAPPADS = "tappads",
  DREAMCOIN_CLICK = "dreamcoin_click",
  DREAMCOIN_SUBSCRIBE = "dreamcoin_subscribe",
  BARZHA_CLICK = "barzha_click",
  FLYER = "flyer",
}

export class SponsorsTasksAdapter {
  static async adaptTasks(
    sponsorType: SponsorType,
    response:
      | BarzhaResponse
      | TappAdsTask[]
      | FlyerTask[]
      | DreamcoinResponse
      | any[],
    statusTasks?:
      | BarzhaStatusTask[]
      | TappAdsStatusTask[]
      | FlyerStatusTask[]
      | DreamcoinResponse
  ): Promise<Task[]> {
    console.log("🔄 SponsorsTasksAdapter.adaptTasks - start", {
      sponsorType,
      response,
      statusTasks,
    });

    switch (sponsorType) {
      case SponsorType.BARZHA:
        return BarzhaAdapter.adaptTasks(
          response as BarzhaResponse,
          statusTasks as BarzhaStatusTask[]
        );

      // case SponsorType.TAPPADS:
      //   return TappAdsAdapter.adaptTasks(
      //     response as TappAdsTask[],
      //     statusTasks as TappAdsStatusTask[]
      //   );

      case SponsorType.DREAMCOIN_CLICK:
        return DreamcoinClickAdapter.adaptTasks(
          response as DreamcoinResponse,
          statusTasks as DreamcoinResponse
        );

      case SponsorType.DREAMCOIN_SUBSCRIBE:
        return DreamcoinSubscribeAdapter.adaptTasks(
          response as DreamcoinResponse,
          statusTasks as DreamcoinResponse
        );

      case SponsorType.BARZHA_CLICK:
        return BarzhaClickAdapter.adaptTasks(response as any[]);

      case SponsorType.FLYER:
        return FlyerAdapter.adaptTasks(
          response as FlyerTask[],
          statusTasks as FlyerStatusTask[]
        );

      default:
        console.warn(`Unknown sponsor type: ${sponsorType}`);
        return [];
    }
  }
}
